import { render, staticRenderFns } from "./DenunciaFiscal.vue?vue&type=template&id=06050679&scoped=true&"
import script from "./DenunciaFiscal.vue?vue&type=script&lang=js&"
export * from "./DenunciaFiscal.vue?vue&type=script&lang=js&"
import style0 from "./DenunciaFiscal.vue?vue&type=style&index=0&id=06050679&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06050679",
  null
  
)

export default component.exports